import * as classNames from "classnames";
import * as React from "react";
import * as myClasses from "../../../../components";

import { IProps, Tab, TabId, Tabs } from "@blueprintjs/core";

import "./styles.css";

export interface IListTabsProps extends IProps {
  panel: JSX.Element;
  tabs: Array<string>;
  tabNum: TabId;
  onChangeTabs?(newTabId: TabId, prevTabId: TabId, event: any): void;
}

export const ListTabs: React.SFC<IListTabsProps> = props => {
  const { className, onChangeTabs, panel, tabs, tabNum } = props;
  const classes = classNames(myClasses.LIST_TAB_CONTAINER, className);

  return (
    <Tabs
      className={classes}
      id={myClasses.LIST_TAB}
      selectedTabId={tabNum}
      onChange={onChangeTabs}
    >
      {tabs.map((title: any, index: number) => (
        <Tab
          id={index}
          key={index}
          title={title}
          panel={tabNum === index ? panel : undefined}
        />
      ))}
    </Tabs>
  );
};

export default ListTabs;



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/list-tabs/list-tabs.tsx